exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[readonly] {\nbackground-color: white;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-items-list/reimbursement-manager-items-list.component.css
// module id = ../../../../../src/app/reimbursement/reimbursement-manager-items-list/reimbursement-manager-items-list.component.css
// module chunks = main